module.exports = __webpack_public_path__ + "static/media/favicon.86b05b24.ico";